<template>
  <div class="satc-wrapper" @click.self="$emit('skip')">
    <div class="satc" role="dialog" aria-modal="true" :aria-label="i18n.title" ref="satc" tabindex="-1">
      <div class="satc__header" :style="{backgroundColor: headerColor}">
        <div class="satc__close icon__bg-circle" role="button" tabindex="0" :aria-label="i18n.skip"
             @click.stop="$emit('skip')"
             @keydown.enter.stop="$emit('skip')"
             @keydown.space.prevent.stop="$emit('skip')">
          <span class="icon-cross2" aria-hidden="true"></span>
        </div>
        <h2>{{ introText }}</h2>
        <div class="satc__header__subtitle" v-if="headerSubtitle">{{ headerSubtitle }}</div>
      </div>
      <div class="satc__body">
        <div class="satc__date">
          <label>{{ i18n.from_date }}</label>
          <DateSelector
            :date="fromDate"
            :width100="true"
            @changed="setFromDate">
          </DateSelector>
        </div>
        <div class="satc__date">
          <OnwardEndDate
            :enddate.sync="enddate"
            :minDate="fromDate"
            :label="i18n.set_end_date">
          </OnwardEndDate>
        </div>
        <div class="satc__actions">
          <button class="do-bttn" @click.stop="$emit('skip')">{{ i18n.skip }}</button>
          <button class="do-bttn do-bttn--submit" @click.stop="onConfirm">{{ i18n.confirm }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from '../datepicker/DateSelector'
import OnwardEndDate from '../Calendars/OnwardEndDate'
import moment from 'moment'

const I18N = {
  user: {
    add: {
      da: {
        title: 'Sæt underviser på skemalagte brikker?',
        intro: 'Vil du sætte %{name} på alle skemalagte brikker?',
        subtitle: '%{subject} fra d. %{date}',
        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
        from_date: 'Gælder fra',
        set_end_date: 'Sæt slutdato',
        skip: 'Kun brikken',
        confirm: 'Ja, sæt på skemalagte'
      },
      en: {
        title: 'Assign teacher to scheduled lessons?',
        intro: 'Do you want to assign %{name} to all scheduled lessons?',
        subtitle: '%{subject} from %{date}',
        subtitle_until: '%{subject} from %{date} until %{endDate}',
        from_date: 'Apply from',
        set_end_date: 'Set end date',
        skip: 'Subject only',
        confirm: 'Yes, assign to scheduled'
      },
      nb: {
        title: 'Sett lærer på timeplanlagte brikker?',
        intro: 'Vil du sette %{name} på alle timeplanlagte brikker?',
        subtitle: '%{subject} fra %{date}',
        subtitle_until: '%{subject} fra %{date} til %{endDate}',
        from_date: 'Gjelder fra',
        set_end_date: 'Sett sluttdato',
        skip: 'Kun faget',
        confirm: 'Ja, sett på timeplanlagte'
      }
    },
    remove: {
      da: {
        title: 'Fjern underviser fra skemalagte brikker?',
        intro: 'Vil du fjerne %{name} fra alle skemalagte brikker?',
        subtitle: '%{subject} fra d. %{date}',
        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
        from_date: 'Gælder fra',
        set_end_date: 'Sæt slutdato',
        skip: 'Kun brikken',
        confirm: 'Ja, fjern fra skemalagte'
      },
      en: {
        title: 'Remove teacher from scheduled lessons?',
        intro: 'Do you want to remove %{name} from all scheduled lessons?',
        subtitle: '%{subject} from %{date}',
        subtitle_until: '%{subject} from %{date} until %{endDate}',
        from_date: 'Apply from',
        set_end_date: 'Set end date',
        skip: 'Subject only',
        confirm: 'Yes, remove from scheduled'
      },
      nb: {
        title: 'Fjern lærer fra timeplanlagte brikker?',
        intro: 'Vil du fjerne %{name} fra alle timeplanlagte brikker?',
        subtitle: '%{subject} fra %{date}',
        subtitle_until: '%{subject} fra %{date} til %{endDate}',
        from_date: 'Gjelder fra',
        set_end_date: 'Sett sluttdato',
        skip: 'Kun faget',
        confirm: 'Ja, fjern fra timeplanlagte'
      }
    }
  },
  klass: {
    add: {
      da: {
        title: 'Sæt klasse på skemalagte brikker?',
        intro: 'Vil du sætte %{name} på alle skemalagte brikker?',
        subtitle: '%{subject} fra d. %{date}',
        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
        from_date: 'Gælder fra',
        set_end_date: 'Sæt slutdato',
        skip: 'Kun brikken',
        confirm: 'Ja, sæt på skemalagte'
      },
      en: {
        title: 'Assign class to scheduled lessons?',
        intro: 'Do you want to assign %{name} to all scheduled lessons?',
        subtitle: '%{subject} from %{date}',
        subtitle_until: '%{subject} from %{date} until %{endDate}',
        from_date: 'Apply from',
        set_end_date: 'Set end date',
        skip: 'Subject only',
        confirm: 'Yes, assign to scheduled'
      },
      nb: {
        title: 'Sett klasse på timeplanlagte brikker?',
        intro: 'Vil du sette %{name} på alle timeplanlagte brikker?',
        subtitle: '%{subject} fra %{date}',
        subtitle_until: '%{subject} fra %{date} til %{endDate}',
        from_date: 'Gjelder fra',
        set_end_date: 'Sett sluttdato',
        skip: 'Kun faget',
        confirm: 'Ja, sett på timeplanlagte'
      }
    },
    remove: {
      da: {
        title: 'Fjern klasse fra skemalagte brikker?',
        intro: 'Vil du fjerne %{name} fra alle skemalagte brikker?',
        subtitle: '%{subject} fra d. %{date}',
        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
        from_date: 'Gælder fra',
        set_end_date: 'Sæt slutdato',
        skip: 'Kun brikken',
        confirm: 'Ja, fjern fra skemalagte'
      },
      en: {
        title: 'Remove class from scheduled lessons?',
        intro: 'Do you want to remove %{name} from all scheduled lessons?',
        subtitle: '%{subject} from %{date}',
        subtitle_until: '%{subject} from %{date} until %{endDate}',
        from_date: 'Apply from',
        set_end_date: 'Set end date',
        skip: 'Subject only',
        confirm: 'Yes, remove from scheduled'
      },
      nb: {
        title: 'Fjern klasse fra timeplanlagte brikker?',
        intro: 'Vil du fjerne %{name} fra alle timeplanlagte brikker?',
        subtitle: '%{subject} fra %{date}',
        subtitle_until: '%{subject} fra %{date} til %{endDate}',
        from_date: 'Gjelder fra',
        set_end_date: 'Sett sluttdato',
        skip: 'Kun faget',
        confirm: 'Ja, fjern fra timeplanlagte'
      }
    }
  },
  room: {
    add: {
      da: {
        title: 'Sæt lokale på skemalagte brikker?',
        intro: 'Vil du sætte %{name} på alle skemalagte brikker?',
        subtitle: '%{subject} fra d. %{date}',
        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
        from_date: 'Gælder fra',
        set_end_date: 'Sæt slutdato',
        skip: 'Kun brikken',
        confirm: 'Ja, sæt på skemalagte'
      },
      en: {
        title: 'Assign room to scheduled lessons?',
        intro: 'Do you want to assign %{name} to all scheduled lessons?',
        subtitle: '%{subject} from %{date}',
        subtitle_until: '%{subject} from %{date} until %{endDate}',
        from_date: 'Apply from',
        set_end_date: 'Set end date',
        skip: 'Subject only',
        confirm: 'Yes, assign to scheduled'
      },
      nb: {
        title: 'Sett lokale på timeplanlagte brikker?',
        intro: 'Vil du sette %{name} på alle timeplanlagte brikker?',
        subtitle: '%{subject} fra %{date}',
        subtitle_until: '%{subject} fra %{date} til %{endDate}',
        from_date: 'Gjelder fra',
        set_end_date: 'Sett sluttdato',
        skip: 'Kun faget',
        confirm: 'Ja, sett på timeplanlagte'
      }
    },
    remove: {
      da: {
        title: 'Fjern lokale fra skemalagte brikker?',
        intro: 'Vil du fjerne %{name} fra alle skemalagte brikker?',
        subtitle: '%{subject} fra d. %{date}',
        subtitle_until: '%{subject} fra d. %{date} til d. %{endDate}',
        from_date: 'Gælder fra',
        set_end_date: 'Sæt slutdato',
        skip: 'Kun brikken',
        confirm: 'Ja, fjern fra skemalagte'
      },
      en: {
        title: 'Remove room from scheduled lessons?',
        intro: 'Do you want to remove %{name} from all scheduled lessons?',
        subtitle: '%{subject} from %{date}',
        subtitle_until: '%{subject} from %{date} until %{endDate}',
        from_date: 'Apply from',
        set_end_date: 'Set end date',
        skip: 'Subject only',
        confirm: 'Yes, remove from scheduled'
      },
      nb: {
        title: 'Fjern lokale fra timeplanlagte brikker?',
        intro: 'Vil du fjerne %{name} fra alle timeplanlagte brikker?',
        subtitle: '%{subject} fra %{date}',
        subtitle_until: '%{subject} fra %{date} til %{endDate}',
        from_date: 'Gjelder fra',
        set_end_date: 'Sett sluttdato',
        skip: 'Kun faget',
        confirm: 'Ja, fjern fra timeplanlagte'
      }
    }
  }
}

export default {
  components: {DateSelector, OnwardEndDate},
  props: {
    teacherNames: {
      type: String,
      default: ''
    },
    initialDate: {
      default: null
    },
    mode: {
      type: String,
      default: 'add'
    },
    calendarKind: {
      type: String,
      default: 'user'
    },
    color: {
      type: String,
      default: ''
    },
    subjectName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fromDate: this.initialDate || moment().format('YYYY-MM-DD'),
      enddate: null
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      const kindTexts = I18N[this.calendarKind] || I18N.user
      const modeTexts = kindTexts[this.mode] || kindTexts.add
      return modeTexts[this.locale] || modeTexts.da
    },
    introText () {
      return this.i18n.intro.replace('%{name}', this.teacherNames || '')
    },
    headerColor () {
      return this.color || '#A0A5EF'
    },
    formattedFromDate () {
      return moment(this.fromDate).locale(this.locale).format('D. MMMM YYYY')
    },
    formattedEndDate () {
      if (!this.enddate) return ''
      return moment(this.enddate).locale(this.locale).format('D. MMMM YYYY')
    },
    headerSubtitle () {
      if (!this.subjectName) return ''
      const template = this.enddate && this.i18n.subtitle_until ? this.i18n.subtitle_until : this.i18n.subtitle
      return template
        .replace('%{subject}', this.subjectName)
        .replace('%{date}', this.formattedFromDate)
        .replace('%{endDate}', this.formattedEndDate)
    }
  },
  methods: {
    setFromDate (date) {
      this.fromDate = moment(date).format('YYYY-MM-DD')
      if (this.enddate && this.enddate < this.fromDate) {
        this.enddate = this.fromDate
      }
    },
    onConfirm () {
      this.$emit('confirm', {
        fromDate: this.fromDate,
        enddate: this.enddate || null
      })
    },
    handleKeydown (event) {
      if (event.key === 'Escape') {
        this.$emit('skip')
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
    this.$nextTick(() => {
      if (this.$refs.satc) this.$refs.satc.focus()
    })
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style scoped>
.satc-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1212121212;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 14vh;
  background-color: rgba(98, 103, 109, 0.2);
}

.satc {
  position: relative;
  width: 100%;
  max-width: 420px;
  background: #f6f9fc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  animation: satcFadeUp 0.25s;
  outline: none;
}

.satc__header {
  position: relative;
  padding: 20px 44px 20px 20px;
  color: #ffffff;
  border-radius: 4px 4px 0 0;
}

.satc__header h2 {
  color: #ffffff;
  margin: 0;
  font-size: 1.15rem;
  line-height: 1.35;
  font-weight: 700;
}

.satc__header__subtitle {
  margin-top: 6px;
  color: #ffffff;
  opacity: 0.9;
  font-size: 0.9rem;
  font-weight: 400;
}

.satc__close {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  color: #ffffff;
}

.satc__close:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}

.satc__body {
  padding: 1.25rem 1.5rem 1.25rem;
}

.satc__date {
  margin-bottom: 1.25rem;
}

.satc__date label {
  letter-spacing: 0.075rem;
  text-transform: uppercase;
  font-size: 0.85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

.satc__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

@keyframes satcFadeUp {
  from {
    transform: scale(0.95);
    opacity: 0.9;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// SubjectAssignTeacherToEventsConfirm.vue?2c9c445e